// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Tabs-module--cds--assistive-text--dbe80";
export var cdsHideFeedback = "Tabs-module--cds--hide-feedback--bbd67";
export var cdsShowFeedback = "Tabs-module--cds--show-feedback--1aef4";
export var cdsSkeleton = "Tabs-module--cds--skeleton--94541";
export var cdsVisuallyHidden = "Tabs-module--cds--visually-hidden--383c8";
export var dropdownWrapper = "Tabs-module--dropdownWrapper--0c721";
export var panel = "Tabs-module--panel--2a0af";
export var tab = "Tabs-module--tab--59c2a";
export var tabList = "Tabs-module--tab-list--f46b0";
export var tabs = "Tabs-module--tabs--5fdb3";